import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { thaiDate } from "../../components/site/siteText";
import { apiUrl, getArticle } from "../../services/newspaperApi";
import ArticleCredit from "./ArticleCredit";
import RichText, { plainText } from "../../components/site/RichText";
import "./newspaper.css";

// One admin news / PR article on the website (the same article is also in the daily edition)
function ArticlePage() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setArticle(null);
    setError("");
    getArticle(id)
      .then((d) => {
        if (!active) return;
        setArticle(d.article);
        document.title = `${d.article.title} | Maneenopkao Group`;
      })
      .catch((e) => active && setError(e.message));
    return () => { active = false; };
  }, [id]);

  if (error) {
    return (
      <main id="main" className="container submit-page">
        <Link className="breadcrumb" to="/newspaper">← หนังสือพิมพ์</Link>
        <div className="empty-state">
          <span>↳</span>
          <h3>{error}</h3>
          <p>ข่าวนี้อาจยังไม่ถึงวันเผยแพร่ หรือถูกนำออกแล้ว</p>
        </div>
      </main>
    );
  }

  if (!article) return <main id="main" className="container submit-page"><p className="no-notices">กำลังโหลดข่าว…</p></main>;

  return (
    <main id="main" className="container submit-page article-page">
      <Link className="breadcrumb" to="/newspaper">← หนังสือพิมพ์</Link>
      <article className="book-article article-web">
        <p className="eyebrow">{article.category} · {thaiDate(article.issueDate)}</p>
        <h1>{article.title}</h1>
        {article.author && <p className="article-byline">เรียบเรียงโดย {article.author}</p>}
        {article.summary && <p className="article-lead">{plainText(article.summary)}</p>}
        {(article.files || []).slice(0, 1).map((f) => (
          <img key={f.url} className="article-cover" src={apiUrl(f.url)} alt={article.title} />
        ))}
        <div className="reading-body">
          <RichText text={article.body} />
        </div>
        {(article.documents || []).map((d) => (
          <a key={d.url} className="notice-cell-pdf article-pdf-link" href={apiUrl(d.url)} target="_blank" rel="noreferrer">
            <strong>{d.name || "ไฟล์ PDF"}</strong>
            <span>เปิดไฟล์ PDF ↗</span>
          </a>
        ))}
        {(article.files || []).length > 1 && (
          <div className="article-gallery">
            {article.files.slice(1).map((f) => <img key={f.url} src={apiUrl(f.url)} alt={article.title} />)}
          </div>
        )}
        <ArticleCredit article={article} />
        <div className="article-actions">
          <Link className="button dark" to={{ pathname: `/newspaper/editions/${article.issueDate}`, hash: `article-${article.id}` }}>
            อ่านในฉบับรายวัน{" "}
            <span>↗</span>
          </Link>
          <Link className="text-link" to="/newspaper">
            ข่าวและประกาศทั้งหมด{" "}
            <span>→</span>
          </Link>
        </div>
      </article>
    </main>
  );
}

export default ArticlePage;
